import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';

import { removeAllCookies } from '../services/cookies';
import { setSessionCookie } from '../services/session';
import { getSessionCookie } from '../services/session';

import { api_GET } from '../services/api_service';
import { showMessage } from '../services/message';

//Helpers

function initialContext() {
    return {
        loading: false,
        isSignout: false,
        session: null
    }
}

export const AuthContext = createContext(initialContext());

const AuthProvider = ({ children }) => {
    //Estados de autenticação
    const [loading, setLoading] = useState(false);
    const [session, setSession] = useState(null);
    const [setupSistema, setSetupSistema] = useState(null);


    const signIn = useCallback(async (data) => {
        await setSessionCookie(data);
        setSession(data);
    }, []);

    const signOut = useCallback(async (token, callback) => {
        if (!token) removeAllCookies();
        setSession(null);
        if (callback) callback();
    }, []);

    const loadSetupSistema = useCallback(() => {
        setLoading(true);
        api_GET('SetupGeral')
            .then(result => { setSetupSistema(result.data) })
            .catch(err => showMessage("Aviso", err.message, 'error', null))
            .finally(() => setLoading(false))
    }, []);

    const loadAsync = useCallback(async () => {
        setLoading(true);
        try {
            const data = await getSessionCookie();
            setSession(data);
        } catch (e) {
            console.error("Error loading session:", e);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        loadSetupSistema();
        loadAsync();
    }, [loadAsync])

    return (
        <AuthContext.Provider value={{
            session,
            loading,
            setLoading,
            signIn,
            signOut,
            setupSistema
        }}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    const context = useContext(AuthContext)
    return context;
}

export default AuthProvider;